import { z } from 'zod'
import type { AsyncFn } from '../../common'
import type { CompanyGuid, ForCompany } from './Company'

export const DEFAULT_COMPANY_CREATION_PREFERENCES = {
  requireJobSummaryOnCreate: true,
  requireVisitDescriptionOnCreate: false,
} as const

export type CompanyCreationPreferences = {
  requireJobSummaryOnCreate: boolean
  requireVisitDescriptionOnCreate: boolean
}

export const CompanyCreationPreferencesPatchSchema = z
  .object({
    requireJobSummaryOnCreate: z.boolean().or(z.undefined()),
    requireVisitDescriptionOnCreate: z.boolean().or(z.undefined()),
  })
  .strict()
  .refine(
    value => value.requireJobSummaryOnCreate !== undefined || value.requireVisitDescriptionOnCreate !== undefined,
    'Change at least one creation preference.',
  )

export type CompanyCreationPreferencesPatch = z.infer<typeof CompanyCreationPreferencesPatchSchema>
export type CompanyCreationPreferencesReader = AsyncFn<CompanyGuid, ForCompany<CompanyCreationPreferences>>
export type CompanyCreationPreferencesWriter = AsyncFn<
  ForCompany<CompanyCreationPreferencesPatch>,
  ForCompany<CompanyCreationPreferences>
>
